export const SET_EDITED = "SET_EDITED";



// WEBPACK FOOTER //
// ./src/store/actions/edited.js